import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';



export default function DialogoDetalle({ open, fullWidth, maxWidth, handleClickOpen, handleMaxWidthChange, handleFullWidthChange, handleClose }) {

  return (
    <>

      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}

        open={open}
        onClose={handleClose}
      >
        <DialogTitle></DialogTitle>
        <DialogContent>
          <DialogContentText>
            EJECUCION
          </DialogContentText>
          <Box
            noValidate
            component="form"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              m: 'auto',
              width: 'fit-content',
            }}
          >
            <p>
              equire all users to register for Microsoft Entra multifactor authentication
              All users have 14 days to register using the Microsoft Authenticator app or any app supporting OATH TOTP. After the 14 days pass, the user can't sign in until registration is completed. A user's 14-day period begins after their first successful interactive sign-in after enabling security defaults.

              When users sign in and are prompted to perform multifactor authentication, they see a screen providing them with a number to enter in the Microsoft Authenticator app. This measure helps prevent users from falling for MFA fatigue attacks.

              Screenshot showing an example of the Approve sign in request window with a number to enter.

              Require administrators to do multifactor authentication
              Administrators have increased access to your environment. Because of the power these highly privileged accounts have, you should treat them with special care. One common method to improve the protection of privileged accounts is to require a stronger form of account verification for sign-in, like requiring multifactor authentication.

              Tip

              Recommendations for your admins:

              Ensure all your admins sign in after enabling security defaults so that they can register for authentication methods.
              Have separate accounts for administration and standard productivity tasks to significantly reduce the number of times your admins are prompted for MFA.
              After registration is finished, the following administrator roles will be required to do multifactor authentication every time they sign in:

              Global Administrator
              Application Administrator
              Authentication Administrator
              Billing Administrator
              Cloud Application Administrator
              Conditional Access Administrator
              Exchange Administrator
              Helpdesk Administrator
              Password Administrator
              Privileged Authentication Administrator
              Privileged Role Administrator
              Security Administrator
              SharePoint Administrator
              User Administrator
              Authentication Policy Administrator
              Identity Governance Administrator
              Require users to do multifactor authentication when necessary
              We tend to think that administrator accounts are the only accounts that need extra layers of authentication. Administrators have broad access to sensitive information and can make changes to subscription-wide settings. But attackers frequently target end users.

              After these attackers gain access, they can request access to privileged information for the original account holder. They can even download the entire directory to do a phishing attack on your whole organization.

              One common method to improve protection for all users is to require a stronger form of account verification, such as multifactor authentication, for everyone. After users complete registration, they'll be prompted for another authentication whenever necessary. Microsoft decides when a user is prompted for multifactor authentication, based on factors such as location, device, role, and task. This functionality protects all registered applications, including SaaS applications.
            </p>

          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}